import { LOCATION_IDS } from './constants';

export interface NpcDef {
  id: string;
  name: string;
  locationId: string;
}

export const NPC_DEFS: NpcDef[] = [
  { id: 'olaf', name: 'Merchant Olaf', locationId: LOCATION_IDS.MARKET },
  { id: 'old_fisherman', name: 'Old Fisherman', locationId: LOCATION_IDS.POND },
  { id: 'hermit', name: 'Hermit', locationId: LOCATION_IDS.LAKE },
  { id: 'sailor', name: 'Sailor', locationId: LOCATION_IDS.COAST },
];

export function getNpcsAtLocation(locationId: string): string[] {
  return NPC_DEFS.filter(n => n.locationId === locationId).map(n => n.name);
}
